/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/smartSuggestUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/smart-suggest-util.js
**/

var SmartSuggestUtil = {};

SmartSuggestUtil = (function() {
	
	var _airportAjaxUrl = '/awardMap/api/airports';
	
	var initialize = function() {
		initSmartEvents('#originInput');
		initSmartSuggestValidator();
	};
	
   function smartSuggestAirports(locField) {
       $(locField).autocomplete({
           delay: 200,
           // minLength: 3 so that no suggestions are displayed before the user enters 3 characters
           minLength: 3,
           source: function(request, response) {
               $.ajax({
                   url: _airportAjaxUrl,
                   dataType: "json",
                   data: {
                       name: request.term
                   },
                   success: function(data) {
                       //data = (data == null) ? "" : (($.isArray(data.list.Airport)) ? data.list.Airport : $.makeArray(data.list.Airport));
                       response($.map(data, function(item) {
                           return {
                               label: item.code + " - " + item.name + (item.countryCode == "MO" || item.countryCode == "TW" || item.countryCode == "HK" || item.countryName == "" ? "" : ", " + (item.countryCode == "US" ? item.stateCode : item.countryName)),
                               value: item.code
                           };
                       }));
                   }
               });
           }
       });
   }

   var initSmartEvents = function(field) {
       var $field = $(field);
       smartSuggestAirports(field);

       $field.focus(function () {
           // if not already initialized, initialize
           if (!$(this).is(':data(autocomplete)')) {
               smartSuggestAirports(field);
           }
           $(field).autocomplete("enable");
       });

       $field.blur(function () {
           $(field).autocomplete("disable");
       });
   };
   
   var initSmartSuggestValidator = function() {
	   $('#originInput').blur(function() {
			   isValidAjax($(this).val());
	   });
   };
   
   function isValidAjax(code) {
	   return isValidAjaxSyncAsync(code, true);
   }
   
   function isValidAjaxSynchronous(code) {
	   return isValidAjaxSyncAsync(code, false);
   }
   
   function isValidAjaxSyncAsync(code, async) {
	   var ret = false;
	   $.ajax({
		    url: _airportAjaxUrl + '/' + code,
	   		async: async,
		    dataType: 'json',
		    success: function(data) { 
		       var isValid = false;
		       if(data != null && data.code.toUpperCase() === code.toUpperCase()) {
		    	   isValid = true;		 
		    	   // only update origin marker if no search has been performed
		    	   if(SearchUtil.getNumberOfResults() == null) {
		    		   updateOriginMarkerOnMap(data);		    	
		    	   }
		       }
		       else {
		    	   MapUtil.removeOriginMarker();
		       }
			   $('#originValidResponse .airport').text(code);
			   $('#originValidResponse .isValid').text(isValid);
			   ret = data;
		   }
	   });
	   return ret;
   }
   
   function updateOriginMarker(code) {
	   $.ajax({
		    url: _airportAjaxUrl + '/' + code,
		    dataType: 'json',
		    success: function(data) { 
		       if(data != null && data.code.toUpperCase() === code.toUpperCase()) {
		    	   updateOriginMarkerOnMap(data);
		       }
		       else {
		    	   MapUtil.removeOriginMarker();
		       }
		   }
	   });
   }
   
   function updateOriginMarkerOnMap(data) {
	   MapUtil.updateOriginMarker(data.point.latitude, data.point.longitude, data.name, data.code);
   }
   
   function isValidFromDom(code) {
	   var domCode = $('#originValidResponse .airport').text();
	   var valid = $('#originValidResponse .isValid').text();
	   return code == domCode && valid == 'true';
   }
   
   function isDomUpToDateWithValidatedAirportCode(code) {
	   var domCode = $('#originValidResponse .airport').text();
	   return domCode == code;
   }
   
	
	return {
		initialize : initialize,
		isValidFromDom : isValidFromDom,
		isValidAjaxSynchronous : isValidAjaxSynchronous,
		isDomUpToDateWithValidatedAirportCode : isDomUpToDateWithValidatedAirportCode,
		updateOriginMarker : updateOriginMarker
	};
	
}());
